import React from "react";

/* Delicate floral circle motif */
export const FloralCircle = ({ className = "" }) => (
  <svg className={className} width="120" height="120" viewBox="0 0 120 120" fill="none" aria-hidden="true">
    <circle cx="60" cy="60" r="28" stroke="#C8806A" strokeWidth="0.8" opacity="0.5" strokeDasharray="4 3" />
    <circle cx="60" cy="60" r="18" stroke="#C8806A" strokeWidth="0.6" opacity="0.35" />
    {[0,45,90,135,180,225,270,315].map((deg, i) => {
      const rad = (deg * Math.PI) / 180;
      const x1 = 60 + 28 * Math.cos(rad);
      const y1 = 60 + 28 * Math.sin(rad);
      const x2 = 60 + 44 * Math.cos(rad);
      const y2 = 60 + 44 * Math.sin(rad);
      return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#C8806A" strokeWidth="0.8" opacity="0.45" strokeLinecap="round" />;
    })}
    <circle cx="60" cy="60" r="5" stroke="#C8806A" strokeWidth="0.9" fill="none" opacity="0.5" />
  </svg>
);

/* Scattered dot cluster */
export const DotCluster = ({ className = "" }) => (
  <svg className={className} width="90" height="70" viewBox="0 0 90 70" fill="none" aria-hidden="true">
    {[
      [8,12],[22,5],[36,14],[50,8],[64,18],[78,10],
      [14,28],[30,35],[46,26],[60,33],[74,28],
      [8,48],[22,54],[38,46],[54,52],[68,44],[82,50],
    ].map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r={i % 3 === 0 ? 2 : 1.3} fill="#C8806A" opacity={0.25 + (i % 4) * 0.07} />
    ))}
  </svg>
);

/* Thin decorative arc */
export const ThinArc = ({ className = "" }) => (
  <svg className={className} width="200" height="100" viewBox="0 0 200 100" fill="none" aria-hidden="true">
    <path d="M10,90 Q60,10 100,50 Q140,90 190,20" stroke="#C8806A" strokeWidth="0.9" fill="none" opacity="0.4" strokeLinecap="round" />
    <path d="M10,75 Q65,5 105,40 Q145,75 190,10" stroke="#C8806A" strokeWidth="0.5" fill="none" opacity="0.2" strokeLinecap="round" />
  </svg>
);

/* Botanical line illustrations, used as ambient background art */
export const LeafBranch = ({ className = "", flip = false }) => (
  <svg
    className={className}
    width="160"
    height="320"
    viewBox="0 0 160 320"
    fill="none"
    style={{ transform: flip ? "scaleX(-1)" : undefined }}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M80 10 C72 80, 88 160, 70 230 C64 260, 56 290, 50 315" stroke="#C8806A" strokeWidth="1.1" fill="none" strokeLinecap="round" opacity="0.55" />
    <path d="M76 50 C55 48, 40 60, 30 80 C45 86, 65 78, 76 50 Z" stroke="#C8806A" strokeWidth="1" fill="none" opacity="0.55" />
    <path d="M83 90 C104 88, 119 100, 130 120 C115 126, 92 118, 83 90 Z" stroke="#C8806A" strokeWidth="1" fill="none" opacity="0.55" />
    <path d="M75 130 C54 128, 39 140, 29 160 C44 166, 64 158, 75 130 Z" stroke="#C8806A" strokeWidth="1" fill="none" opacity="0.55" />
    <path d="M80 175 C100 173, 116 184, 125 204 C110 210, 88 200, 80 175 Z" stroke="#C8806A" strokeWidth="1" fill="none" opacity="0.55" />
    <path d="M70 220 C50 220, 36 232, 26 252 C42 257, 60 248, 70 220 Z" stroke="#C8806A" strokeWidth="1" fill="none" opacity="0.55" />
  </svg>
);

export const SmallSprig = ({ className = "" }) => (
  <svg className={className} width="80" height="32" viewBox="0 0 80 32" fill="none" aria-hidden="true">
    <path d="M2 16 C20 16, 40 16, 78 16" stroke="#B8694F" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M70 16 C72 12, 76 10, 78 16 C76 18, 73 18, 70 16 Z" fill="#B8694F" />
    <path d="M70 16 C68 20, 64 22, 62 16" stroke="#B8694F" strokeWidth="1" fill="none" />
  </svg>
);

export const Blob = ({ className = "" }) => (
  <div className={`absolute pointer-events-none ${className}`} aria-hidden="true">
    <svg viewBox="0 0 400 500" width="100%" height="100%">
      <path
        d="M40,200 C40,90 130,30 220,55 C310,80 360,180 340,280 C320,380 230,440 140,420 C50,400 40,310 40,200 Z"
        fill="#F1E6D6"
        opacity="0.8"
      />
    </svg>
  </div>
);

export default LeafBranch;
